module.exports = __webpack_public_path__ + "img/18.10.pH.85667201.png";